import { reportOptions, ReportType } from './reportConfig';
import PageHero from '../ui/PageHero';

interface ReportTypeSelectorProps {
  onSelect: (reportId: ReportType) => void;
}

export default function ReportTypeSelector({ onSelect }: ReportTypeSelectorProps) {
  return (
    <div>
      <PageHero
        title="Reports"
        subtitle="Generate professional reports for your bird management operations"
      />

      <div className="mt-8">
        <h2 className="text-lg font-medium text-slate-900 mb-4">Operational Reports</h2>
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {reportOptions
            .filter((r) => r.category === 'operational')
            .map((report) => {
              const Icon = report.icon;
              return (
                <button
                  key={report.id}
                  onClick={() => onSelect(report.id)}
                  className="relative overflow-hidden rounded-lg bg-white px-4 pb-12 pt-5 shadow hover:shadow-md transition-shadow sm:px-6 sm:pt-6 text-left"
                >
                  <dt>
                    <div className="absolute rounded-md bg-gradient-to-br from-cyan-500 to-violet-500 p-3">
                      <Icon className="h-6 w-6 text-white" aria-hidden="true" />
                    </div>
                    <p className="ml-16 truncate text-sm font-medium text-slate-500">{report.name}</p>
                  </dt>
                  <dd className="ml-16 pb-6 sm:pb-7">
                    <p className="text-sm text-slate-600">{report.description}</p>
                  </dd>
                </button>
              );
            })}
        </div>
      </div>

      <div className="mt-8">
        <h2 className="text-lg font-medium text-slate-900 mb-4">Financial Reports</h2>
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          {reportOptions
            .filter((r) => r.category === 'financial')
            .map((report) => {
              const Icon = report.icon;
              return (
                <button
                  key={report.id}
                  onClick={() => onSelect(report.id)}
                  className="relative overflow-hidden rounded-lg bg-white px-4 pb-12 pt-5 shadow hover:shadow-md transition-shadow sm:px-6 sm:pt-6 text-left"
                >
                  <dt>
                    <div className="absolute rounded-md bg-green-500 p-3">
                      <Icon className="h-6 w-6 text-white" aria-hidden="true" />
                    </div>
                    <p className="ml-16 truncate text-sm font-medium text-slate-500">{report.name}</p>
                  </dt>
                  <dd className="ml-16 pb-6 sm:pb-7">
                    <p className="text-sm text-slate-600">{report.description}</p>
                  </dd>
                </button>
              );
            })}
        </div>
      </div>
    </div>
  );
}
